export const currencycents = (total: number): string => {
  return Intl.NumberFormat('en-LK', {
    style: 'currency',
    currency: 'LKR',
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  }).format(total);
};
